import { AutoMap } from '@automapper/classes';
import { Allow, IsNumberString, IsString } from 'class-validator';

export class LocaleDto {
  @IsString()
  @IsNumberString()
  @AutoMap()
  id: string;

  @IsString()
  @Allow()
  displayLabel: string;

  @IsString()
  @AutoMap()
  localeName: string;
}
